export const VIEW_LIST = "list"
export const VIEW_UNMAPPED = "unmapped"
export const VIEW_TASK = "task"
export const VIEW_DRAFTS = "drafts"

export const MODE_BROWSE = "browse"
export const MODE_UNMAPPED = "unmapped"
export const MODE_DRAFTS = "drafts"
